function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1
}, React.createElement("path", {
  d: "M80,160 C35.81722,160 0,124.18278 0,80 C0,35.81722 35.81722,0 80,0 C124.18278,0 160,35.81722 160,80 C160,124.18278 124.18278,160 80,160 Z M80,72 C93.254834,72 104,61.254834 104,48 C104,34.745166 93.254834,24 80,24 C66.745166,24 56,34.745166 56,48 C56,61.254834 66.745166,72 80,72 Z M79.9905519,138 C79.9937012,138 79.9968505,138 80,138 C80.0031495,138 80.0062988,138 80.0094481,137.999999 C99.9612145,137.996819 117.559091,127.919449 127.993289,112.577683 C127.560402,98.965365 106.238855,88 80,88 C53.7611445,88 32.4395976,98.965365 32.0067107,112.577679 C42.4409087,127.919449 60.0387855,137.996819 79.9905519,137.999999 Z"
}));

var SvgAccountIcon = function SvgAccountIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAccountIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/account-icon.2218142b.svg";
export { ForwardRef as ReactComponent };